import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border mt-auto" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2" data-testid="footer-logo">
          <img src="/logo-mark.png" alt="BookdHUB" className="w-6 h-6 rounded-sm" />
          <span className="font-display text-base tracking-tight">
            <span className="font-semibold text-foreground">Bookd</span><span className="font-bold text-primary">HUB</span>
          </span>
        </Link>

        <p className="text-xs text-muted-foreground order-last sm:order-none" data-testid="footer-copyright">
          &copy; {year} BookdHUB. All rights reserved.
        </p>

        <nav className="flex items-center gap-6 text-sm">
          <Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-terms-link">
            Terms of Service
          </Link>
          <Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-privacy-link">
            Privacy Policy
          </Link>
        </nav>
      </div>
    </footer>
  );
}
